// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyPhotoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  UserPropertyPhotoPollPhotoIdsResponseWebDto,
  UserPropertyPhotoUploadResponseWebDto,
} from '../..';

interface PollPhotoIdsParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path =
  '/api/web/v1/users/properties/photos/generateUploadUrl';

/**
 * Generate a time-limited photo upload URL for the QR-code phone upload flow
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl = (
  postData: UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyPhotoGenerateUploadUrlRequestWebDto, string>(
    {
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path =
  '/api/web/v1/users/properties/photos/pollPhotoIds';

/**
 * List the encoded photo ids of a listing, for the QR upload flow to poll for changes
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds = (
  getParams: PollPhotoIdsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PollPhotoIdsParams, never, UserPropertyPhotoPollPhotoIdsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_upload_Path = '/api/web/v1/users/properties/photos/upload';

/**
 * Upload a property photo
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyFloorPlanPhotoUploadRequestWebDto,
    UserPropertyPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
